import React from "react";
import useMetaTags from "../../hooks/useMetaTags"; // Adjust path based on your project structure

const UnderstandingPeriodHealth = () => {
  useMetaTags({
    title: "Understanding Period Health | Track & Improve Menstrual Wellness",
    description: "Learn how to track your menstrual cycle, understand period symptoms, and make informed choices for better menstrual health. Discover key benefits today!",
    keywords: "period health, menstrual wellness, tracking period cycle, hormone balance, reproductive health, best period products, period tracking tips",
    author: "Organic Pads",
    robots: "index, follow",
    canonical: "/understanding-period-health",
    ogTitle: "Understanding Period Health | Track & Improve Menstrual Wellness",
    ogDescription: "Your period is a key indicator of overall health. Learn how to track your cycle, understand symptoms, and make better choices for menstrual wellness.",
    ogImage: "https://img.freepik.com/free-photo/doctors-coat-with-flowers-clipboard-pen-uterus-doctor-gynecologist_185193-108339.jpg",
    ogUrl: "https://organicpads.shop/understanding-period-health",
    ogType: "article",
    twitterCard: "summary_large_image",
    twitterTitle: "Understanding Period Health | Track & Improve Menstrual Wellness",
    twitterDescription: "Tracking your period cycle helps detect health issues early and improves your overall menstrual wellness. Learn more today!",
    twitterImage: "https://img.freepik.com/free-photo/doctors-coat-with-flowers-clipboard-pen-uterus-doctor-gynecologist_185193-108339.jpg",
    twitterSite: "@OrganicPads",
    twitterCreator: "@OrganicPads",
  });

  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "/understanding-period-health"
    },
    "headline": "Understanding Period Health | Track & Improve Menstrual Wellness",
    "description": "Learn how to track your menstrual cycle, understand period symptoms, and make informed choices for better menstrual health. Discover key benefits today!",
    "image": "https://img.freepik.com/free-photo/doctors-coat-with-flowers-clipboard-pen-uterus-doctor-gynecologist_185193-108339.jpg",
    "author": {
      "@type": "Organization",
      "name": "Organic Pads",
      "url": "/"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Organic Pads",
      "logo": {
        "@type": "ImageObject",
        "url": "/logo.png"
      }
    },
    "datePublished": "2025-02-24",
    "dateModified": "2025-02-24",
    "keywords": [
      "period health",
      "menstrual wellness",
      "tracking period cycle",
      "hormone balance",
      "reproductive health",
      "best period products",
      "period tracking tips"
    ]
  }
  
  return (
    <>
    <div className="max-w-3xl mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h1 className="text-3xl font-bold text-gray-900 mb-4">
        Understanding Period Health
      </h1>
      <img
        src="https://img.freepik.com/free-photo/doctors-coat-with-flowers-clipboard-pen-uterus-doctor-gynecologist_185193-108339.jpg?ga=GA1.1.567354764.1736148549&semt=ais_hybrid"
        alt="Period Health Guide"
        className="w-full rounded-lg mb-4"
      />
      <p className="text-gray-700 mb-4">
        Understanding your menstrual health is crucial for overall wellbeing. Your period is more than just a monthly occurrence - it's an indicator of your body's health and hormonal balance. Making informed choices about menstrual products can significantly impact your health journey.
      </p>

      <h2 className="text-2xl font-semibold text-gray-800 mb-3">Benefits of Understanding Your Cycle</h2>
      <ul className="list-disc list-inside text-gray-700 mb-4">
        <li>Better prediction of menstrual symptoms</li>
        <li>Early detection of health issues</li>
        <li>Improved hormone balance awareness</li>
        <li>Enhanced reproductive health knowledge</li>
        <li>Better product choices for your needs</li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-800 mb-3">How to Track Your Period Health?</h2>
      <p className="text-gray-700 mb-4">
        Use a <strong>period tracking app</strong> or journal to monitor your cycle length, symptoms, and flow patterns. This information helps you make better decisions about your menstrual care products and overall health.
      </p>
      <img
        src="https://images.unsplash.com/photo-1712842955521-55c8c01ef148?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8b3JnYW5pYyUyMHNhbml0YXJ5JTIwcGFkc3xlbnwwfHwwfHx8MA%3D%3D"
        alt="Period Tracking"
        className="w-full rounded-lg mb-4"
      />

      <h2 className="text-2xl font-semibold text-gray-800 mb-3">Final Thoughts</h2>
      <p className="text-gray-700 mb-4">
        Taking control of your period health leads to better overall wellness.
        <strong> Start your journey to better menstrual health today!</strong>
      </p>
    </div>
     {/* Schema Markup */}
     <script type="application/ld+json">
        {JSON.stringify(schemaMarkup)}
      </script>
    </>
  );
};

export default UnderstandingPeriodHealth;
